import { Dispatch } from "redux"
import { SponsoredProductAction, SponsoredProductActionType } from "../types/sponsoredProducts"
import campaignApi from "../../api/campaignApi"
import { IFetchSponsoredProductCampaignData } from "../../types/campaigns"

const fetchSponsoredProductCampaigns = (data: IFetchSponsoredProductCampaignData) => {
  return async (dispatch: Dispatch<SponsoredProductAction>) => {
    try {
      dispatch({ type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS })
      const sponsoredProductData = await campaignApi.getCampaignsData(data)

      dispatch({
        type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS,
        payload: sponsoredProductData.data,
      })
    } catch (e) {
      dispatch({
        type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR,
        payload: "sponsored product load error",
      })
    }
  }
}

export default {
  fetchSponsoredProductCampaigns,
}
